import { Route, Routes, BrowserRouter } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

import Home from "../pages/home";
import GoogleAccount from "../pages/googleAccount";

const AppRoutes = () => {

    const { instance, accounts, inProgress } = useMsal();
    const [accountName, setAccountName] = useState();

    useEffect(() => {

        // Wait until MsalProvider has finished initializing/handling the redirect response
        if (inProgress !== InteractionStatus.None) {
            return;
        }

        const activeAccount = instance.getActiveAccount();
        if (activeAccount) {
            setAccountName(activeAccount.username);
            return;
        }

        if (accounts.length > 0) {
            // Default to using the first account if no account is active
            instance.setActiveAccount(accounts[0]);
            setAccountName(accounts[0].username);
            return;
        }

        // No signed-in account found, redirect anonymous user to the login page
        instance.loginRedirect().catch(err => {
          // TODO: Handle errors
          console.log(err);
        });

      }, [instance, accounts, inProgress]);



    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Home accountName={accountName}/>} path="/" />
                <Route element={<GoogleAccount accountName={accountName} />} path="/google" />
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes;